import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()({
  wrapper: {
    margin: '0px 30px 20px 30px',
    width: 'calc(100% - 60px)',
    height: 'calc(100vh - 260px)',
    maxHeight: 'calc(100vh - 260px)',
    boxSizing: 'border-box',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    marginBottom: 8,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  chatContainer: {
    position: 'relative',
    height: 'auto',
    flex: 1,
    minHeight: 0,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    '& > .cs-main-container': {
      flex: 1,
      minHeight: 0,
      height: 'auto',
    },
  },
  messageInputWrapper: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: 8,
    padding: 8,
    backgroundColor: '#FFFFFF',
    borderTop: '1px solid #E1E2E3',
    minHeight: 72,
    maxHeight: 112,
    flex: '0 0 auto',
    position: 'relative',
    zIndex: 10,
    boxSizing: 'border-box',
  },
  messageField: {
    flex: 1,
    minWidth: 0,
    visibility: 'visible',
    '& .MuiOutlinedInput-root': {
      paddingRight: 12,
    },
  },
  actionButtons: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    visibility: 'visible',
  },
  voiceError: {
    color: '#B3261E',
    fontSize: 12,
    padding: '4px 12px',
  },
  markdown: {
    '& p': {
      margin: '0 0 8px',
    },
    '& table': {
      borderCollapse: 'collapse',
      margin: '8px 0',
      minWidth: 280,
      width: '100%',
      fontSize: 13,
    },
    '& th, & td': {
      border: '1px solid #D9DADC',
      padding: '6px 8px',
      textAlign: 'left',
    },
    '& th': {
      backgroundColor: '#F1F2F3',
      fontWeight: 700,
    },
    '& ul, & ol': {
      margin: '4px 0 8px',
      paddingLeft: 20,
    },
  },
});
